import { NgModule } from '@angular/core';

//import { CharacterButtonComponent } from './shared/character-button/character-button.component';
//import { SortCharactersPipe } from './shared/sort-characters.pipe';
import { NewsRoutingModule, routedComponents } from './news-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ArticleService } from './shared/article.service';
import { NgxGalleryModule } from 'ngx-gallery';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the module

@NgModule({
  imports: [
    NewsRoutingModule,
    SharedModule,
    NgxGalleryModule,
    NgxPaginationModule
  ],
  declarations: [
    routedComponents],

})
export class NewsModule { }



// WEBPACK FOOTER //
// ./src/app/news/news.module.ts